export default __webpack_public_path__ + "static/media/img_18.386702d6.jpg";